module.exports = __webpack_public_path__ + "d0014d87bc2cab8393c2dabd71b8a217.svg";